import React from 'react';
import "./contact.css";

export default function ContatUs() {
  return (
    <div className='container '>
        <div className="row d-flex justify-content-center">
        <div className="col-12 col-md-4">
                    <div style={{marginTop:"150px"}} className="card" >
                        <img src="https://thumbs.dreamstime.com/b/profile-anonymous-face-icon-gray-silhouette-person-male-businessman-profile-default-avatar-photo-placeholder-isolated-white-113133662.jpg" className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h5 className="card-title contact-card-title">Yakshap Tyagi</h5>
                            <p className="card-text contact-card-text">Web Developer - ReactJS</p>
                            <a href="https://www.linkedin.com/in/yakshap-tyagi-42a90b1b5/" target="blank">
                                <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="linkedIn" className="linkedIn" />
                            </a>
                        </div>
                    </div>
                </div>
        </div>

    </div>
  )
}
